import script from "./ProfileSetupView.vue?vue&type=script&setup=true&lang=js"
export * from "./ProfileSetupView.vue?vue&type=script&setup=true&lang=js"

import "./ProfileSetupView.vue?vue&type=style&index=0&id=6385efb6&scoped=true&lang=css"

import exportComponent from "../../../author/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6385efb6"]])

export default __exports__